/**
 * Centralised feature flags for settings pages.
 *
 * Set to `true` to enable the My Account page in user settings.
 */
export const ACCOUNT_PAGE_ENABLED = false;

/**
 * Set to `true` to expose per-server profile editing (server identities).
 */
export const SERVER_PROFILES_ENABLED = false;

/**
 * Set to `true` to show the Create / Join Server button in the server list.
 */
export const CREATE_SERVER_ENABLED = false;

/**
 * Set to `true` to enable the GIF picker within the composer.
 */
export const GIF_PICKER_ENABLED = false;

/**
 * Set to `true` to run the client in single-server deploy mode.
 */
export const SINGLE_SERVER_DEPLOY = true;
